export default {
    menu: [],
    logo:
    {
        "url": null,
        "link": "",
        "alt_text": "Logo del Encabezado",
        "styles": "{}"
    }
};